import { render } from "./ExamFilter.vue?vue&type=template&id=48a21824&scoped=true"
import script from "./ExamFilter.vue?vue&type=script&lang=js"
export * from "./ExamFilter.vue?vue&type=script&lang=js"

import "./ExamFilter.vue?vue&type=style&index=0&id=48a21824&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a21824"]])

export default __exports__